import initialState from './initialState'

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_SPECIALIZATION':
      return action.specialization
    default:
      return state
  }
}

export default reducer
